import MailEingaenge from '../../komponenten/MailEingaenge'

/**
 * Die Mails, die in den Bereich Rohstoffnotierungen sortiert wurden - mit dem Grund der Sortierung
 * und dem Lauf, der daraus wurde. Postfach und erlaubte Absender pflegt die Verpackung unter
 * Einstellungen; sie gelten für beide Bereiche.
 */
export default function EingaengeSeite() {
  return (
    <>
      <h2>Eingänge</h2>
      <p className="hinweis" style={{ maxWidth: '75ch' }}>
        Mails mit Notierungen aus beiden Postfächern. Eine Mail, deren Bereich unklar ist, steht unter Verpackung · Stammdaten
        · Einstellungen und wird dort per Knopf zugeordnet.
      </p>
      <MailEingaenge bereich="notierungen" />
    </>
  )
}
